export enum FileAttachmentType {
    COMPLIANCEITEM = 1,
    COMPLIANCECYCLE = 2,
    NOTE = 3,
    USERFORM=4,
    REQUESTITEM=5,
    USER_REQUEST=6,
    USER_REQUEST_FOLLOWUP=7
}